import { ModalConfirmationOptions } from '@/utils/modal'
import { generals } from '@puls/puls-general-utils'

export enum NOTIFICATION_TYPES {
	success = 'success', error = 'error', info = 'info'
}

export interface NotificationItem {
	uuid: string,
	type: NOTIFICATION_TYPES,
	message: string,
	duration: number,
	code: string
}

export const generateNotificationItem = (
	{ type = NOTIFICATION_TYPES.info, message = '', duration = 5000, code = '' }
) : NotificationItem => {
	return {
		uuid: generals.generateUuid(),
		type,
		message,
		duration, 
		code
	}
}

export interface ConfirmationModal {
	confirmation?: ModalConfirmationOptions
}

export interface ImagesModal {
	images?: string[],
	initialIndex?: number
}

export interface GeneralModalProperties {
	data?: any
}

export interface ModalItem extends ConfirmationModal, ImagesModal, GeneralModalProperties{
	show: boolean,
	uuid: string,
	type: string,
	imagesData?: ImagesModal,
	fullscreen?: boolean,
	plansToShow?: number[]
}

export interface AppConfig {
	notifications: NotificationItem[],
	modals: ModalItem[],
	httpInProgress: boolean
}
